// extracted by mini-css-extract-plugin
export var container = "MainIntro-module--container--X0ORH";
export var background = "MainIntro-module--background---EsWx";
export var backgroundResponsive = "MainIntro-module--backgroundResponsive--zWz5K";
export var logo = "MainIntro-module--logo--Dmxz9";
export var aboutUsText = "MainIntro-module--aboutUsText--3byBj";
export var xray = "MainIntro-module--xray--VMr4L";